import { render } from "./Experience.vue?vue&type=template&id=67fb4c4e&scoped=true"
const script = {}

import "./Experience.vue?vue&type=style&index=0&id=67fb4c4e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67fb4c4e"]])

export default __exports__